
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DateTimePicker from "@/components/DateTimePicker/index.vue";
import getDate from "@/views/company/getDate"
import { handleFill, timeFormat } from "@/utils/util";
import dayjs from 'dayjs'

@Component({
  components: { DateTimePicker },
})
export class SearchPopup extends Vue {
  @Prop({ default: () => { } }) defaultValue: any // 把confirm传出去的值传回来回显数据
  @Prop({ default: require("@/assets/images/shouyin/statement/calendar.png") })
  btnSrc: string; // 按钮图标 require('@/assets/images/shouyin/statement/calendar.png')
  @Prop({ default: "时间选择" }) popupTitle: string; // popup标题
  @Prop({ default: "自定义日期" }) customDateText: string; // 自定义日期文本
  placeholder1 = '开始日期'
  placeholder2 = '结束日期'
  show = false;
  // 1今天 2昨天 3本周 4上周 5本月 6上月 7自定义日期
  selectType = 1
  list = [
    {
      title: "选择时间",
      isShow: true,
      selected: 1,
      options: [
        { label: "今天", value: 1 },
        { label: "昨天", value: 2 },
        { label: "本周", value: 3 },
        { label: "上周", value: 4 },
        { label: "本月", value: 5 },
        { label: "上月", value: 6 },
      ],
    },
  ];

  @Watch("show")
  onShowChange (newVal) {
    if (newVal) {
      if (this.defaultValue) {
        const { value, datetimeVal1, datetimeVal2, datetimeValueType, showDatetimePicker } = this.defaultValue
        this.selectType = value
        // 初始化日期/时间选择组件
        this.selectType == 7 && this.executeDateTimePickerInit({ valueType: datetimeValueType, showDatetimePicker, datetimeVal1, datetimeVal2 })
      }
    } else {
      // 重置日期/时间选择组件
      this.selectType == 7 && (this.$refs.dateTimePickerRef as any).resetData();
    }
  }

  @Watch("selectType")
  onSelectTypeChange (newVal, oldVal) {
    if (oldVal == 7) {
      // 重置日期/时间选择组件
      (this.$refs.dateTimePickerRef as any).resetData();
    }
  }

  mounted () {
     // 如果组件已经传值进来，不需要再抛出组件数据
    if (this.defaultValue) return;
    this.onConfirm();
  }

  showPopup () {
    this.show = true;
  }

  // 递归初始化日期/时间选择组件，防止拿不到dateTimePicker没有初始化完成的情况
  async executeDateTimePickerInit (
    params: {
      valueType: any;
      showDatetimePicker: boolean;
      datetimeVal1: any;
      datetimeVal2: any;
    },
    maxRetries = 10,
    interval = 50
  ) {
    const { valueType, showDatetimePicker, datetimeVal1, datetimeVal2 } = params;
    // 检查必要的值是否存在
    if (!datetimeVal1 || !datetimeVal2) {
      return;
    }

    for (let i = 0; i < maxRetries; i++) {
      const ref = this.$refs.dateTimePickerRef as any;

      if (ref?.initData) {
        // 找到 initData，执行并返回
        ref.initData({
          valueType,
          showDatetimePicker,
          datetimeVal1,
          datetimeVal2
        });
        return;
      }
      // 等待一段时间后重试
      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }

  onSelectOption (option) {
    this.selectType = option.value;
  }

  // 获取1今天 2昨天 3本周 4上周 5本月 6上月的开始结束时间
  getDateFunc (timeType: number) {
    let days
    switch (timeType) {
      // 今日
      case 1:
        days = getDate.getToday()
        break
      // 昨日
      case 2:
        days = getDate.getYesterday()
        break
      // 本周
      case 3:
        days = getDate.getCurrWeekDays()
        break
      // 上周
      case 4:
        days = getDate.getLastWeekDays()
        break
      // 本月
      case 5:
        days = getDate.getCurrMonthDays()
        break
      // 上月
      case 6:
        days = getDate.getLastMonthDays()
        break
    }
    return days
  }

  // 获取当前时间文本
  getNowTimeText (starttime: string, endtime: string) {
    // 是否是范围值（除了今日、昨日都是范围值）
    const isRange = ![1, 2].includes(this.selectType)
    const nowTimeText = timeFormat(starttime) + (isRange ? ` - ${timeFormat(endtime)}` : '')
    return handleFill(nowTimeText)
  }

  onCancel () {
    this.show = false;
  }

  onConfirm () {
    let res = null
    if (this.selectType == 7) {
      const { datetimeVal1, datetimeVal2 } = (this.$refs.dateTimePickerRef as any).picker;
      if (!datetimeVal1) {
        this.$toast(`请选择${this.placeholder1}`)
        return false
      }
      if (!datetimeVal2) {
        this.$toast(`请选择${this.placeholder2}`)
        return false
      }
      const { formatDateTime, valueType: datetimeValueType, showDatetimePicker } = (this.$refs.dateTimePickerRef as any);
      const starttime = formatDateTime(datetimeVal1)
      const endtime = formatDateTime(datetimeVal2)
      // 转换为时间戳比较时间大小
      if (dayjs(starttime).valueOf() > dayjs(endtime).valueOf()) {
        this.$toast(`${this.placeholder1}不能大于${this.placeholder2}`)
        return false
      }
      res = {
        label: this.customDateText,
        value: this.selectType,
        // 回显
        datetimeVal1,
        datetimeVal2,
        datetimeValueType,
        showDatetimePicker,
        // 传参
        starttime,
        endtime,
        // 显示
        nowTimeText: this.getNowTimeText(starttime, endtime)
      }
    } else {
      const option = this.list.map(
        (item) =>
          item.options.find((option) => option.value === this.selectType)
      );
      const days = this.getDateFunc(this.selectType)
      const { starttime, endtime } = days
      res = {
        ...option[0],
        starttime,
        endtime,
        nowTimeText: this.getNowTimeText(starttime, endtime)
      }
    }
    this.$emit("confirm", res);
    this.show = false;
  }
}
export default SearchPopup;
